import { render, staticRenderFns } from "./detailsTd.vue?vue&type=template&id=5dc556b0&scoped=true&"
import script from "./detailsTd.vue?vue&type=script&lang=js&"
export * from "./detailsTd.vue?vue&type=script&lang=js&"
import style0 from "./detailsTd.vue?vue&type=style&index=0&id=5dc556b0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dc556b0",
  null
  
)

export default component.exports